import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputDropdown from '../../common/Forms/InputDropdown';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { CommonDropDownStyle } from '../../ui/styled';

const StartEndCounty = (props) => {
  const { cancelPopUp, setCancelPopUp, title, countyList, submit } = props;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [county, setCounty] = useState(null);

  const handleCancel = () => {
    setCancelPopUp(false);
  };

  const handleSubmit = () => {
    if (startDate && endDate && county) {
      setCancelPopUp(false);
      submit(startDate, endDate, countyList.filter(c => c.id==county)[0]);
    }  
  };

  return (
    <Dialog fullWidth={true} maxWidth={'xs'} open={cancelPopUp}>
      <DialogTitle>
        <Typography variant="h5">
          {title}
        </Typography>  
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              id="startDate"
              label="Start Date"
              value={startDate}
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => {
                setStartDate(event.target.value);
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="endDate"
              label="End Date"
              value={endDate}
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={(event) => {
                setEndDate(event.target.value);
              }}
            />            
          </Grid>
          <Grid item xs={12}>
            <CommonDropDownStyle>
              <InputLabel id="county">County</InputLabel>
              <Select
                labelId="county"
                id="county"
                value={county}
                label="Age"
                onChange={(event) => {
                  setCounty(event.target.value);
                }}
              >
              {
                countyList?.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={item.id}
                    >
                      {item.value}
                    </MenuItem>
                  )                  
                })
              }  
              </Select>
            </CommonDropDownStyle>  
          </Grid>
        </Grid>    
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant='contained' onClick={handleSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StartEndCounty;
